module.exports = __webpack_public_path__ + "img/logo.36eb3a60.svg";